import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { CompanyConfigService } from '../../services/company-config.service';

interface ServicePlan {
  name: string;
  subtitle: string;
  features: string[];
  buttonText: string;
  buttonAction: () => void;
  popular?: boolean;
}

@Component({
  selector: 'app-service-offerings',
  templateUrl: './service-offerings.component.html',
  styleUrl: './service-offerings.component.css',
  imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule]
})
export class ServiceOfferingsComponent {
  
  constructor(
    private router: Router,
    public companyConfig: CompanyConfigService
  ) {}

  servicePlans: ServicePlan[] = [
    {
      name: 'Basic Pest Control',
      subtitle: 'Essential pest protection against common pests.',
      features: [
        'Interior and exterior pest inspection',
        'Protection from 25+ common household pests',
        'Regularly scheduled pest treatments',
        'Complete Pest Guarantee: Free re-treatment if pests return after our services.'
      ],
      buttonText: 'Get Quote',
      buttonAction: () => this.navigateToContact()
    },
    {
      name: 'Complete Pest Control',
      subtitle: 'Comprehensive year-round pest protection',
      features: [
        'Interior and exterior pest inspection',
        'Protection from 35+ common household pests',
        'Every-other-month pest treatments',
        'Complete Pest Guarantee with priority service',
        'PLUS seasonal pest prevention treatments'
      ],
      buttonText: 'Get Quote',
      buttonAction: () => this.navigateToContact(),
      popular: true
    },
    {
      name: 'One-Time Treatment',
      subtitle: 'Single pest problem solution',
      features: [
        'Interior and exterior inspection',
        'One comprehensive pest treatment',
        'Complete Pest Guarantee 30-day guarantee on all services.'
      ],
      buttonText: 'Get Quote',
      buttonAction: () => this.navigateToContact()
    }
  ];

  navigateToContact() {
    this.router.navigate(['/contact']);
  }

  callPhone() {
    this.companyConfig.callPhone();
  }
}